module.exports = __webpack_public_path__ + "static/media/projectManagement.ec3fdd46.svg";